import { CoreIcon } from '../core-icon';
import visibilitySVG from '../../assets/icons/visibility.svg';
import type { IconProps } from '../core-icon';

export const VisibilityIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={visibilitySVG} {...props} />;
};
